export type SteelLengthDisplayUnit = "mm" | "in";
export type PlatePlanDisplayUnit = "ft" | "in";

export interface CommercialSteelSize {
  mm: number;
  inch: string;
}

export const plateThicknesses: CommercialSteelSize[] = [
  { inch: "3/16", mm: 4.8 },
  { inch: "1/4", mm: 6.4 },
  { inch: "5/16", mm: 7.9 },
  { inch: "3/8", mm: 9.5 },
  { inch: "7/16", mm: 11.1 },
  { inch: "1/2", mm: 12.7 },
  { inch: "9/16", mm: 14.3 },
  { inch: "5/8", mm: 15.9 },
  { inch: "3/4", mm: 19.1 },
  { inch: "7/8", mm: 22.2 },
  { inch: "1", mm: 25.4 },
  { inch: "1 1/8", mm: 28.6 },
  { inch: "1 1/4", mm: 31.8 },
  { inch: "1 3/8", mm: 34.9 },
  { inch: "1 1/2", mm: 38.1 },
  { inch: "1 5/8", mm: 41.3 },
  { inch: "1 3/4", mm: 44.5 },
  { inch: "2", mm: 50.8 },
  { inch: "2 1/4", mm: 57.2 },
  { inch: "2 1/2", mm: 63.5 },
  { inch: "2 3/4", mm: 69.8 },
  { inch: "3", mm: 76.2 },
  { inch: "3 1/2", mm: 88.9 },
  { inch: "4", mm: 101.6 },
  { inch: "4 1/2", mm: 114.3 },
  { inch: "5", mm: 127.0 },
  { inch: "5 1/2", mm: 139.7 },
  { inch: "6", mm: 152.4 },
];

export const commercialBarSizes: CommercialSteelSize[] = [
  { mm: 12.7, inch: "1/2" },
  { mm: 14.3, inch: "9/16" },
  { mm: 15.9, inch: "5/8" },
  { mm: 17.5, inch: "11/16" },
  { mm: 19.0, inch: "3/4" },
  { mm: 20.6, inch: "13/16" },
  { mm: 22.2, inch: "7/8" },
  { mm: 23.8, inch: "15/16" },
  { mm: 25.4, inch: "1" },
  { mm: 26.9, inch: "1 1/16" },
  { mm: 28.6, inch: "1 1/8" },
  { mm: 30.2, inch: "1 3/16" },
  { mm: 31.7, inch: "1 1/4" },
  { mm: 33.3, inch: "1 5/16" },
  { mm: 34.9, inch: "1 3/8" },
  { mm: 38.1, inch: "1 1/2" },
  { mm: 41.3, inch: "1 5/8" },
  { mm: 44.4, inch: "1 3/4" },
  { mm: 49.2, inch: "1 15/16" },
  { mm: 50.8, inch: "2" },
  { mm: 52.4, inch: "2 1/16" },
  { mm: 54.0, inch: "2 1/8" },
  { mm: 55.6, inch: "2 3/16" },
  { mm: 57.2, inch: "2 1/4" },
  { mm: 60.3, inch: "2 3/8" },
  { mm: 63.5, inch: "2 1/2" },
  { mm: 69.9, inch: "2 3/4" },
  { mm: 76.2, inch: "3" },
  { mm: 82.6, inch: "3 1/4" },
  { mm: 88.9, inch: "3 1/2" },
  { mm: 95.2, inch: "3 3/4" },
  { mm: 101.6, inch: "4" },
  { mm: 108.0, inch: "4 1/4" },
  { mm: 114.3, inch: "4 1/2" },
  { mm: 120.7, inch: "4 3/4" },
  { mm: 127.0, inch: "5" },
  { mm: 133.4, inch: "5 1/4" },
  { mm: 139.7, inch: "5 1/2" },
  { mm: 146.1, inch: "5 3/4" },
  { mm: 152.4, inch: "6" },
  { mm: 165.1, inch: "6 1/2" },
  { mm: 177.8, inch: "7" },
  { mm: 203.2, inch: "8" },
  { mm: 215.9, inch: "8 1/2" },
  { mm: 228.6, inch: "9" },
  { mm: 241.3, inch: "9 1/2" },
  { mm: 254.0, inch: "10" },
  { mm: 266.7, inch: "10 1/2" },
  { mm: 279.4, inch: "11" },
  { mm: 292.1, inch: "11 1/2" },
  { mm: 304.8, inch: "12" },
  { mm: 330.2, inch: "13" },
  { mm: 355.6, inch: "14" },
  { mm: 381.0, inch: "15" },
  { mm: 406.4, inch: "16" },
  { mm: 431.8, inch: "17" },
  { mm: 457.2, inch: "18" },
  { mm: 482.6, inch: "19" },
  { mm: 508.0, inch: "20" },
];

export interface CommercialPlatePlan {
  widthFt: number;
  lengthFt: number;
}

export const commercialPlatePlans: CommercialPlatePlan[] = [
  { widthFt: 3, lengthFt: 6 },
  { widthFt: 3, lengthFt: 8 },
  { widthFt: 3, lengthFt: 10 },
  { widthFt: 4, lengthFt: 8 },
  { widthFt: 4, lengthFt: 10 },
  { widthFt: 5, lengthFt: 10 },
  { widthFt: 5, lengthFt: 20 },
  { widthFt: 6, lengthFt: 20 },
  { widthFt: 6, lengthFt: 40 },
  { widthFt: 8, lengthFt: 20 },
  { widthFt: 8, lengthFt: 40 },
  { widthFt: 10, lengthFt: 40 },
];

export const feetToMm = (feet: number) => Number((feet * 304.8).toFixed(1));
export const inchesToMm = (inches: number) => Number((inches * 25.4).toFixed(1));

export function commercialSizeLabel(size: CommercialSteelSize, unit: SteelLengthDisplayUnit) {
  return unit === "in" ? `${size.inch}″` : `${size.mm.toLocaleString("es-MX", { maximumFractionDigits: 1 })} mm`;
}

export function platePlanLabel(feet: number, unit: PlatePlanDisplayUnit) {
  return unit === "ft" ? `${feet}′` : `${feet * 12}″`;
}

export function uniquePlateWidths() {
  return [...new Set(commercialPlatePlans.map((item) => item.widthFt))].sort((a, b) => a - b);
}

export function plateLengthsForWidth(widthFt: number | null) {
  if (widthFt == null) return [];
  return [...new Set(
    commercialPlatePlans
      .filter((item) => item.widthFt === widthFt)
      .map((item) => item.lengthFt),
  )].sort((a, b) => a - b);
}

export function mmToPlateFeet(mm: unknown) {
  const numeric = Number(mm);
  if (!Number.isFinite(numeric)) return null;
  const match = [...uniquePlateWidths(), ...commercialPlatePlans.map((item) => item.lengthFt)]
    .find((feet) => Math.abs(feetToMm(feet) - numeric) < 0.2);
  return match ?? null;
}
